// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3IrFI","filesListContainer":"PosDisputesFiles_filesListContainer__2kqff","filesButton":"PosDisputesFiles_filesButton__1Qgxn"};